module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gc-Ha-Ia.208c36b7.png";